module.exports = __webpack_public_path__ + "static/media/Exitmenu.b55474d3.svg";